/**
 * This file is generated AUTOMATICALLY, please do not edit it!
 */

export type ErrorContextValue = boolean | number | string;

export const enum ErrorCode {
  UNEXPECTED_ERROR = 'UnexpectedError',
  TOKEN_EXPIRED_ERROR = 'TokenExpiredError',
  JSON_WEB_TOKEN_ERROR = 'JsonWebTokenError',
  AUTH_SIGNUP_ABORTED_ERROR = 'AuthSignupAbortedError',
  AUTH_SIGNUP_ERROR = 'AuthSignupError',
  AUTH_SIGNUP_INITIAL_REQUEST_ABORTED_ERROR = 'AuthSignupInitialRequestAbortedError',
  IDENTITY_CONFIRMATION_CODE_EXPIRED = 'IdentityConfirmationCodeExpired',
  OTP_FAILED_TO_SEND_VERIFICATION_CODE_ERROR = 'OTPFailedToSendVerificationCodeError',
  AUTH_SIGNUP_CONFIRMATION_ERROR = 'AuthSignupConfirmationError',
  IDENTITY_CONFIRMATION_SIGNATURE_INVALID = 'IdentityConfirmationSignatureInvalid',
  IDENTITY_CONFIRMATION_CODE_NOT_FOUND = 'IdentityConfirmationCodeNotFound',
  OTP_FAILED_TO_VERIFY_CODE_ERROR = 'OTPFailedToVerifyCodeError',
  ENTITY_NOT_FOUND_ERROR = 'EntityNotFoundError',
  STRIPE_CONFIRM_PAYMENT_INTENT_ERROR = 'StripeConfirmPaymentIntentError',
  INSUFFICIENT_POINTS_ERROR = 'InsufficientPointsError',
  INVALID_OPERATION_ERROR = 'InvalidOperationError',
  NOMINATION_DAILY_LIMIT_ERROR = 'NominationDailyLimitError',
  NOMINATION_ALREADY_CLAIMED_ERROR = 'NominationAlreadyClaimedError',
  SELF_NOMINATION_ERROR = 'SelfNominationError'
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type ErrorContext = {};
